import { Form, Input } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const ClientShortName: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Form.Item
      name="shortName"
      label="Short Name"
      rules={[
        {
          required: true,
          message: t("error:short_name_is_required"),
        },
      ]}
    >
      <Input />
    </Form.Item>
  );
};

export default ClientShortName;
